import React from 'react'
import { useIsMobile } from '../hooks/useIsMobile'
import { RadBox } from './RadBox'
import { RadButton } from './RadButton'
import { RadDivider } from './RadDivider'
import { RadGrid } from './RadGrid'
import { RadSpaceBetween } from './RadSpaceBetween'

export function RadAttributeEditor ({
  empty,
  removeButtonText,
  addButtonText,
  definition,
  onRemoveButtonClick,
  items,
  onAddButtonClick
}) {
  const isMobile = useIsMobile()
  const gridDefinition = [
    ...definition.map(() => ({ colspan: { default: 12, xs: Math.ceil(10 / definition.length) } })),
    { colspan: { default: 12, xs: 2 } }
  ]

  return (
    <RadSpaceBetween size='l'>
      {items.map((item, itemIndex) =>
        <RadSpaceBetween size='l' key={item.id ?? item.uuid}>
          <RadGrid
            gridDefinition={gridDefinition}
          >
            {definition.map(d =>
              <RadBox key={d.label}>
                {(itemIndex === 0 || isMobile) && d.label && <RadBox variant='awsui-key-label'>{d.label}</RadBox>}
                {d.control(item)}
              </RadBox>
            )}
            <RadBox padding={{ top: isMobile || itemIndex > 0 ? null : 'l' }}>
              <RadButton
                onClick={() => onRemoveButtonClick({ detail: { item, itemIndex } })}
              >
                {removeButtonText}
              </RadButton>
            </RadBox>
          </RadGrid>
          {isMobile && <RadDivider />}
        </RadSpaceBetween>
      )}
      <RadButton
        onClick={() => onAddButtonClick()}
      >
        {addButtonText}
      </RadButton>
    </RadSpaceBetween>
  )
}
